import { DbLoadCargo } from "../../../data/usecases/load-cargo";
import { LoadCargo } from "../../../domain/usecases/load-cargo";
import { makeAxiosHttpClient } from "../http";
import { makeMUApiUrl } from "../http/mu-api-url-factory";

export const makeDbLoadCargo = (): LoadCargo =>
  new DbLoadCargo(makeMUApiUrl("/cargo"), makeAxiosHttpClient());
